import React from 'react';
import EditorToolbar, { modules, formats } from './editor-toolbar';
import ReactQuill from 'react-quill';

const TeksEditor = ({ lang, allValue, value, onChange }) => {
  const changeHandler = (value) => {
    const copyAllValue = [...allValue];
    const choosedValue = copyAllValue.find((item) => item.id === lang.id);

    if (choosedValue) {
      choosedValue.value = value;
      onChange(copyAllValue);
    }
  };

  return (
    <div className="editor-container">
      <div className="text-area-editor">
        <EditorToolbar />
        <ReactQuill
          placeholder="Tulis Template"
          className="text-area"
          value={value}
          onChange={changeHandler}
          modules={modules}
          formats={formats}
        />
      </div>
    </div>
  );
};

export default TeksEditor;
